"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabList = void 0;
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var css_1 = require("@emotion/css");
var react_1 = __importStar(require("react"));
var TabProvider_1 = require("../TabProvider/TabProvider");
var tabsCss = function (selectedTheme) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-wrap: nowrap;\n  position: relative;\n  padding: 0px 4px;\n\n  button {\n    padding: 8px;\n  }\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n    right: 0px;\n    height: ", ";\n    border-radius: ", ";\n    /* stylelint-disable-next-line */\n    background-color: ", ";\n  }\n"], ["\n  display: inline-flex;\n  flex-wrap: nowrap;\n  position: relative;\n  padding: 0px 4px;\n\n  button {\n    padding: 8px;\n  }\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n    right: 0px;\n    height: ", ";\n    border-radius: ", ";\n    /* stylelint-disable-next-line */\n    background-color: ", ";\n  }\n"])), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: '2px', dark: '1px' }), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: '10px', dark: '0' }), (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
    light: design_system_foundations_1.theme.color.neutral50,
    dark: design_system_foundations_1.darkTheme.color.blueGray50,
})); };
var extendedUnderline = function (selectedTheme) { return (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  /* stylelint-disable-next-line */\n  border-bottom: ", " solid ", ";\n  width: 100%;\n  display: block;\n  height: ", ";\n  margin-top: ", ";\n"], ["\n  /* stylelint-disable-next-line */\n  border-bottom: ", " solid ", ";\n  width: 100%;\n  display: block;\n  height: ", ";\n  margin-top: ", ";\n"])), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: '2px', dark: '1px' }), (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
    light: design_system_foundations_1.theme.color.neutral20,
    dark: design_system_foundations_1.darkTheme.color.blueGray100,
}), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: '2px', dark: '1px' }), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: '-4px', dark: '-2px' })); };
var indicatorCss = function (selectedTheme, selectedWidth, xOffset) { return (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  left: calc(", "px - 4px);\n  bottom: ", ";\n  height: ", ";\n  width: calc(", "px + 8px);\n  border-radius: ", ";\n  background-color: ", ";\n  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"], ["\n  position: absolute;\n  left: calc(", "px - 4px);\n  bottom: ", ";\n  height: ", ";\n  width: calc(", "px + 8px);\n  border-radius: ", ";\n  background-color: ", ";\n  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"])), xOffset, (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: '-1px', dark: '0' }), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: '4px', dark: '2px' }), selectedWidth, (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: '10px', dark: '0' }), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.teal70, dark: design_system_foundations_1.darkTheme.color.teal100 })); };
exports.TabList = (0, react_1.forwardRef)(function (_a, ref) {
    var _b, _c, _d, _e, _f, _g;
    var children = _a.children, onChange = _a.onChange, className = _a.className, testId = _a.testId, valueProp = _a.value, _h = _a.isExtended, isExtended = _h === void 0 ? false : _h, rest = __rest(_a, ["children", "onChange", "className", "testId", "value", "isExtended"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var contextValue = (0, react_1.useContext)(TabProvider_1.TabContext).value;
    var value = valueProp || contextValue;
    var _j = (0, react_1.useState)(false), _tabsRendered = _j[0], setTabsRendered = _j[1];
    var tabRefs = (0, react_1.useRef)(react_1.default.Children.toArray(children)
        .filter(function (child) { return react_1.default.isValidElement(child); })
        .reduce(function (acc, child) {
        var tabReferenceObject = acc;
        var tabChild = child;
        tabReferenceObject.set(tabChild.props.value, react_1.default.createRef());
        return acc;
    }, new Map()));
    var handleKeyDown = function (event, index) {
        var _a, _b, _c;
        var tabButtonArray = Array.from((_a = tabRefs.current) === null || _a === void 0 ? void 0 : _a.values());
        var newIndex;
        if (event.key === 'ArrowRight') {
            newIndex = (index + 1) % tabButtonArray.length;
        }
        else if (event.key === 'ArrowLeft') {
            newIndex = index - 1;
        }
        if (newIndex !== undefined) {
            (_c = (_b = tabButtonArray.at(newIndex)) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.focus();
        }
    };
    // I have to rerender component to handle positioning the indicator span correctly, otherwise tabRefs are not set
    var forceComponentUpdateToSetRef = (0, react_1.useCallback)(function () {
        setTabsRendered(function (tabsRendered) {
            if (!tabsRendered) {
                return true;
            }
            return tabsRendered;
        });
    }, [setTabsRendered]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", __assign({}, rest, { "data-testid": testId, role: "tablist", className: (0, css_1.cx)(className, tabsCss(selectedTheme), 'ds-tab-list'), ref: ref }),
            react_1.default.Children.map(children, function (element, index) {
                var _a;
                return react_1.default.isValidElement(element)
                    ? react_1.default.cloneElement(element, {
                        onClick: function (event) { return onChange(event, element.props.value); },
                        onKeyDown: function (event) { return handleKeyDown(event, index); },
                        tabRef: (_a = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current) === null || _a === void 0 ? void 0 : _a.get(element.props.value),
                        onRender: forceComponentUpdateToSetRef,
                        tabListValue: value,
                    })
                    : undefined;
            }),
            value && (react_1.default.createElement("span", { "data-testid": "".concat(testId, "-indicator"), className: indicatorCss(selectedTheme, (_d = (_c = (_b = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current) === null || _b === void 0 ? void 0 : _b.get(value)) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.offsetWidth, (_g = (_f = (_e = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current) === null || _e === void 0 ? void 0 : _e.get(value)) === null || _f === void 0 ? void 0 : _f.current) === null || _g === void 0 ? void 0 : _g.offsetLeft) }))),
        isExtended && react_1.default.createElement("span", { className: extendedUnderline(selectedTheme) })));
});
exports.TabList.displayName = 'TabList';
var templateObject_1, templateObject_2, templateObject_3;
